module.exports = __webpack_public_path__ + "img/ZG81_14.f535b165.jpg";